var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { classNames, getActiveElement } from '@progress/kendo-react-common';
import { Popup } from '@progress/kendo-react-popup';
import { Menu } from '../menu/components/Menu';
/**
 * Represents the [KendoReact ContextMenu component]({% slug overview_contextmenu %}).
 */
export var ContextMenu = function (props) {
    var menuRef = React.useRef(null);
    React.useEffect(function () {
        if (props.show) {
            setTimeout(function () {
                var element = menuRef.current && menuRef.current.element;
                var menuItem = element && element.querySelector('.k-menu-item');
                var activeElement = getActiveElement(menuItem && menuItem.ownerDocument);
                if (menuItem && menuItem !== activeElement) {
                    menuItem.focus();
                }
            });
        }
    }, [props.show]);
    return (React.createElement(Popup, { show: props.show, offset: props.offset, popupClass: 'k-menu-popup', animate: false },
        React.createElement(Menu, __assign({ vertical: true }, props, { ref: menuRef, className: classNames('k-context-menu', props.className), onClose: props.onClose, role: 'menu' }), props.children)));
};
ContextMenu.displayName = 'KendoReactContextMenu';
